// 直播组件
import { useNavigate, useLocation } from 'react-router-dom'
import React, { useState, useEffect, useRef } from 'react'
import { Button, Space, theme } from 'antd'
import { SyncOutlined, FullscreenOutlined } from '@ant-design/icons'
import warning from '@/common/img/video/warning.svg';
import airportWarning from '@/common/img/video/airportWarning.svg';
import { debounce } from '@/common/js/common.js'
// import Aliplayer from 'aliplayer';

const playerErrorInfo = [//直播错误返回code的具体信息
  {
    code: '4001',
    value: '参数不合理',
  },
  {
    code: '4002',
    value: '鉴权过期',
  },
  {
    code: '4003',
    value: '无效地址',
  },
  {
    code: '4004',
    value: '地址不存在',
  },
  {
    code: '4005',
    value: '开始下载数据错误，检测网络情况或播放地址是否可以访问',
  },
  {
    code: '4006',
    value: '开始下载元数据错误',
  },
  {
    code: '4007',
    value: '播放时错误',
  },
  {
    code: '4008',
    value: '加载超时，检测网络情况或播放地址是否可以访问',
  },
  {
    code: '4009',
    value: '请求数据错误，测网络情况或播放地址是否可以访问',
  },
  {
    code: '4010',
    value: '不支持阿里云视频加密（私有加密）播放',
  },
  {
    code: '4011',
    value: '播放格式不支持',
  },
  {
    code: '4012',
    value: 'playauth解析错误',
  },
  {
    code: '4013',
    value: '播放数据解码错误MEDIA_ERR_DECODE，检测浏览器是否支持视频格式',
  },
  {
    code: '4014',
    value: '网络不可用',
  },
  {
    code: '4015',
    value: '获取数据过程被中止MEDIA_ERR_ABORTED',
  },
  {
    code: '4016',
    value: '播网络错误加载数据失败MEDIA_ERR_NETWORK',
  },
  {
    code: '4017',
    value: '返回的播放地址为空',
  },
  {
    code: '4100',
    value: '信令请求失败',
  },
  {
    code: '4110',
    value: '不支持webrtc',
  },
  {
    code: '4111',
    value: '不支持此浏览器',
  },
  {
    code: '4112',
    value: '浏览器版本过低',
  },
  {
    code: '4113',
    value: '不支持H264',
  },
  {
    code: '4114',
    value: 'create offer失败',
  },
  {
    code: '4115',
    value: '自动播放失败',
  },
  {
    code: '4116',
    value: '播放URL协议错误',
  },
  {
    code: '4118',
    value: '订阅时候传入的HtmlElement既不是Audio也不是Video',
  },
  {
    code: '4200',
    value: '播放失败',
  },
  {
    code: '4400',
    value: '未知错误MEDIA_ERR_SRC_NOT_SUPPORTED（由于服务器或网络原因不能加载资源，或者格式不支持）',
  },
  {
    code: '4500',
    value: '服务端请求错误，查看Network里点播服务的请求的具体错误',
  },

]

/**
 * 
 * @param {string} liveUrl  直播地址
 * @returns 
 */
function LiveVideo (props) {

  const navigate = useNavigate();//路由跳转
  const location = useLocation();//路由接受参数
  const {
    token: { colorBgContainer, colorText },
  } = theme.useToken(); //获取主题颜色

  const playerRef = useRef(null);
  const curType = useRef(props.type)//当前选择的种类
  const videoType = useRef(props.videoType)//当前选择  监控视频的种类
  const hasUAVData = useRef(props.hasUAVData)//是否有无人机数据

  const callback = useRef({})
  const [callbackState, setCallbackState] = useState({//回调给父级的数据
    canPushFlow: false,//是否可以 开始推流
    isLivePlay: false,//是否处于直播中
    isLeave: false,//是否离开
    isRefresh: false,//是否刷新
  })

  const [videoStates, setVideoStates] = useState({//直播状态集合
    isMouseEnter: false,//鼠标是否进入直播画面
    isFullScreen: false,//是否全屏
  })

  const isLivePlay = useRef(false)//直播是否处于播放中
  const [isLivePlayState, setIsLivePlayState] = useState(false)//直播是否处于播放中
  const [liveAddress, setLiveAddress] = useState(props.liveUrl)//获取到的地址
  const replayTimesRef = useRef()

  const [errorMessage, setErrorMessage] = useState({
    error_heard: '',//错误主体文字
    error_code: '',// 直播返回的错误code
    error_value: '',//错误补充文字
  })//返回的错误信息


  // Aliplayer配置生命周期
  const StaticAdComponent = Aliplayer.Component({
    play: () => {//播放成功
    },
    waiting: () => {
    },
    playing: () => {//播放中
      console.log('播放中')
      isLivePlay.current = true
      setIsLivePlayState(true)
      // 是否处于直播中 true
      if (!callbackState.isLivePlay) {
        let cal = callbackState
        cal.isLivePlay = true
        setCallbackState({ ...cal })
        callback.current = cal
      }
    },
    error: (player, e) => {//播放错误
      console.log('播放错误')
      // if (liveAddress) {
      let aaa = null
      clearTimeout(aaa);

      aaa = setTimeout(() => {
        replayTimesRef.current += 1
        let aaa = replayTimesRef.current
        playerRef.current.loadByUrl(liveAddress);
      }, 2000);

      if (replayTimesRef.current > 9) {
        clearTimeout(aaa);
        replayTimesRef.current = 0
        let err = errorMessage
        if (e.error_code !== 4003) {
          err.error_heard = e.display_msg ? e.display_msg : e.error_msg
          err.error_code = e.error_code
          err.error_value = playerErrorInfo.find((res) => e.error_code === Number(res.code))?.value
          setErrorMessage({ ...err })
        } else {
          err.error_heard = curType.current === 4 ? 'DJI Mavic 3 直播暂未开启' : '直播暂未开启'
          err.error_code = ''
          err.error_value = ''
          setErrorMessage({ ...err })
        }
        isLivePlay.current = false
        setIsLivePlayState(false)
        setLiveAddress('')
        let cal = callbackState
        cal.isLivePlay = false
        setCallbackState({ ...cal })
        callback.current = cal
      }
      // }
    },
    ended: (player, e) => {//播放结束
      console.log('播放结束')
      isLivePlay.current = false
      setIsLivePlayState(false)
      setLiveAddress('')
      let cal = callbackState
      cal.isLivePlay = false
      setCallbackState({ ...cal })
      callback.current = cal
    }
  });

  useEffect(() => {//监听父传子的数据
    setLiveAddress(props.liveUrl)
    playerRef.current = new Aliplayer(
      {
        id: `Fplayer`,
        source: liveAddress,//视频的播放凭证，可以在通用媒体管理服务控制台获取
        width: '100%', //容器的大小
        height: '100%',
        format: "flv",
        mediaType: "flv",
        autoplay: true,
        isLive: true,
        rePlay: false,
        playsinline: true,
        preload: true,
        controlBarVisibility: "hover",
        useH5Prism: true,
        skinLayout: [
          // { name: "bigPlayButton", align: "blabs", x: 30, y: 80 },
          { name: "H5Loading", align: "blabs", x: "calc(50% - 30px)", y: 'calc(50% - 30px)' },
          // {
          //   name: "controlBar", align: "blabs", x: 0, y: 0,
          //   children: [
          //     { name: "liveDisplay", align: "tlabs", x: 15, y: 6 },
          //     { name: "fullScreenButton", align: "tr", x: 10, y: 10 },
          //   ]
          // }
        ],
        components: [
          { name: 'adComponent', type: StaticAdComponent },
        ]
      }, (player) => {
        player.mute()
        isLivePlay.current = true
        setIsLivePlayState(true)
      }
    );
    playerRef.current.on('liveStreamStop', () => {
      if (liveAddress) {
        localStorage.setItem('log_liveStreamStop', '进入')
        replayTimesRef.current += 1
        if (replayTimesRef.current < 4) { playerRef.current.loadByUrl(liveAddress) }
      }
    })

    return () => {
      if (playerRef.current) { playerRef.current.dispose() }
    }
    // eslint-disable-next-line
    // eslint-disable-next-line
  }, [props.liveUrl, liveAddress])

  useEffect(() => {
    if (props.type === 999 && props.hasUAVData && props.liveUrl === '') {
      console.log('暂无直播，已点击')
      setTimeout(() => {
        document.getElementById('startVideo').click()
      }, 1000);
    } else {
      console.log('有直播')
    }
    // eslint-disable-next-line
  }, [props.hasUAVData])


  useEffect(() => {
    let cal = callbackState
    cal.isLivePlay = isLivePlay.current
    setCallbackState({ ...cal })
    callback.current = cal

    // eslint-disable-next-line
  }, [isLivePlayState])


  useEffect(() => {
    props.liveVideoReturn(callback.current)

    // eslint-disable-next-line
  }, [callbackState])

  useEffect(() => {//监听是否离开当前选项卡
    videoType.current = props.videoType
    hasUAVData.current = props.hasUAVData

    document.addEventListener('visibilitychange', () => {
      const state = document.visibilityState
      if (state === 'hidden') {
        isLivePlay.current = false
        setIsLivePlayState(false)
        let cal = callbackState
        cal.isLeave = true
        setCallbackState({ ...cal })
        callback.current = cal
      } else {
        let cal = callbackState
        cal.isLeave = false
        setCallbackState({ ...cal })
        callback.current = cal
      }
    })

    return () => {//监听是否离开当前页面
      // if (isLivePlay.current) {
      isLivePlay.current = false
      setIsLivePlayState(false)
      let cal = callbackState
      cal.isLivePlay = false
      cal.isLeave = true
      setCallbackState({ ...cal })
      callback.current = cal
      props.liveVideoReturn(cal)
      // }
    }

    // eslint-disable-next-line
  }, [])

  return (
    <div className='hei100 wid100 pos_rel'>
      {/* 直播 */}
      <div id='Fplayer' className='wid100 hei100' />

      <div className='cross pos_abs  wid100 hei100 radius8' style={{ top: 0, left: 0, display: curType.current === 999 ? `` : `none` }} />

      {/* 直播信息组件 */}
      <div
        className='pos_abs wid100 hei100 '
        style={{ top: 0, left: 0, }}
        onMouseEnter={() => {
          let vid = videoStates
          vid.isMouseEnter = true
          setVideoStates({ ...vid })

        }}
        onMouseLeave={() => {
          let vid = videoStates
          vid.isMouseEnter = false
          setVideoStates({ ...vid })
        }}
      >
        <div className='flex_col jcsb wid100 hei100 ' style={{ display: videoStates.isMouseEnter ? `` : `none`, }}
        >
          {/* 直播  头部状态栏 */}
          <div></div>

          {/* 直播  底部状态栏 */}
          <div
            className={`pd10 flex jcsb align_center ${curType.current === 4 ? `h26` : `h51`}`}
            style={{ backgroundColor: 'rgba(0,0,0,0.35)' }}>
            <div
              className={`${curType.current === 4 ? `fs16` : `fs32`}`}
            >
              <Space>
                {/* 直播 */}
                <div className='camera'>
                  live
                </div>

                {/* 刷新 */}
                <SyncOutlined
                  className='pointer fs16'
                  onClick={() => {
                    console.log('刷新了')
                    let err = errorMessage
                    err.error_heard = '刷新中，请稍后···'
                    setErrorMessage({ ...err })
                    isLivePlay.current = false
                    setIsLivePlayState(false)

                    let cal = callbackState
                    cal.isLivePlay = false
                    cal.isRefresh = true
                    setCallbackState({ ...cal })
                    callback.current = cal

                    setTimeout(() => {
                      cal.isRefresh = false
                      callback.current = cal
                      setCallbackState({ ...cal })
                    }, 2000);
                  }}
                />

              </Space>

            </div>

            {/* 右侧 */}
            <div>
              <div
                className={`pointer ${curType.current === 4 ? `fs16` : `fs32`}`}
              >
                <FullscreenOutlined
                  onClick={() => {
                    playerRef.current.fullscreenService.requestFullScreen()//全屏
                    let vid = videoStates
                    vid.isFullScreen = true
                    setVideoStates({ ...vid })
                  }} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 警告信息 */}
      <div
        className='pos_abs hei100 wid100 flex_col jcc align_center'
        style={{ top: 0, left: 0, backgroundColor: '#000', display: isLivePlay.current ? `none` : '', zIndex: 99 }}
      >

        {/* 警告图标 */}
        <img
          src={curType.current === 4 ? airportWarning : warning}
          alt='警告'
          style={{
            height: curType.current === 4 ? '38px' : '80px',
            width: curType.current === 4 ? '38px' : '80px',
            marginBottom: curType.current === 4 ? '10px' : '',
          }}
        />

        {/* 文本 */}
        <div
          className='flex_col jcc align_center'
          style={{ marginBottom: curType.current === 4 ? '10px' : '24px', }}
        >
          {/* 错误主体文字 */}
          <div
            // className="fs24 col_main_text"
            className={`col_main_text ${curType.current === 4 ? 'fs14 lh22 fw400 opa45' : 'fs24 opa88'}`}
          >
            {errorMessage.error_heard}
          </div>

          {/* 错误补充文字 */}
          <div className="fs14 flex col_secondary_text">
            <span className='marR8'>
              {errorMessage.error_code}
            </span>
            <span>
              {errorMessage.error_value}
            </span>
          </div>
        </div>

        {/* 按钮集合 */}
        <div>
          {/* 开启推流 */}
          <Button
            id='startVideo'
            type='primary'
            // disabled={ }
            style={{ display: liveAddress || curType.current === 999 ? `none` : `` }}
            disabled={videoType.current === 'cam' && !props.hasUAVData}
            onClick={() => {
              localStorage.setItem('log111', '开启并观看')
              let cal = callbackState
              cal.canPushFlow = true
              setCallbackState({ ...cal })
              callback.current = cal
            }}
          >
            开启并观看
          </Button>

        </div>

      </div>
    </div>
  )
}
export default LiveVideo;